import { Component } from "@angular/core";

@Component({
  selector: "app-cnet-individual-content",
  templateUrl: "cnet-individual-content.component.html",
})
export class CnetIndividualContentComponent {}
